import ModalManager, { useModal } from '@ebay/nice-modal-react';
import Modal from 'UI/Modal';
import Button from 'UI/Button';
import * as companyResource from 'resources/company/hooks';
import * as userResource from 'resources/user/hooks';
import { SUBSCRIPTION_PLANS } from 'resources/company/company.constants';
import { Pane, Text, IconButton, TickIcon, CrossIcon } from 'evergreen-ui';
import { HomeWhiteIllustration } from 'public/illustrations';
import styles from './styles.module.scss';

const SubscribeModal = ModalManager.create(() => {
  const modal = useModal();
  const { hasAdminPermissions } = userResource.useCurrentUserPermissions();
  const { subscribe } = companyResource.useSubscribe();

  const upgradeNow = async () => {
    await subscribe();
    modal.hide();
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={modal.hide}
      onAfterClose={modal.remove}
      className={styles.noPaddingAndFixedWidth}
    >
      <Pane display="flex" width="100%">

        {/* Left side: illustration and description */}
        <Pane width="50%" display="flex" flexDirection="column" padding={32} backgroundColor="var(--blue-100)" borderTopLeftRadius={6} borderBottomLeftRadius={6} gap={16}>
          <Pane width="100%" display="flex" alignItems="column" justifyContent="center">
            <HomeWhiteIllustration />
          </Pane>
          <Text fontWeight={500} fontSize={20} lineHeight="24px" color="var(--gray-600)" fontFamily="'Zilla Slab', serif">
            {!hasAdminPermissions && 'Please ask your admin to '}
            Upgrade Your Plan
          </Text>
          <Text fontWeight={300} fontSize={14} lineHeight="20px" color="var(--gray-600)" fontFamily="'Merriweather Sans', sans-serif">
            Keep the momentum going!
            Continue managing your transactions with ListedKit.
          </Text>
        </Pane>

        {/* Right side: plan details */}
        <Pane width="50%" display="flex" flexDirection="column">
          <Pane display="flex" justifyContent="flex-end" padding={8}>
            <IconButton onClick={modal.hide} icon={CrossIcon} color="var(--gray-400)" appearance="minimal"/>
          </Pane>
          <Pane display="flex" flexDirection="column" paddingX={32} paddingBottom={32} gap={16}>
            <Pane display="flex" flexDirection="column" gap={4}>
              <Text fontWeight={500} fontSize={12} lineHeight="16px" color="var(--gray-400)" fontFamily="'Roboto', sans-serif" textTransform="uppercase">
                Only ${SUBSCRIPTION_PLANS.GROW.PRICE}/month
              </Text>
              <Text fontWeight={500} fontSize={18} lineHeight="24px" color="var(--gray-600)" fontFamily="'Zilla Slab', serif">
                What's Included:
              </Text>
            </Pane>
            <Pane display="flex" flexDirection="column" gap={12}>
              <TickItem text="Unlimited Coordinators" />
              <TickItem text="Unlimited Transactions" />
              <TickItem text="Unlimited Agents" />
              <TickItem text="Unlimited Clients" />
            </Pane>
            <Pane>
              {hasAdminPermissions ? (
                <Button type="primary" onClick={upgradeNow} >
                  Upgrade Now
                </Button>
              ) : (
                <Button type="primary" onClick={modal.hide} >
                  Close
                </Button>
              )}
            </Pane>
          </Pane>
        </Pane>

      </Pane>
    </Modal>
  );
});

const TickItem = ({ text }) => (
  <Pane display="flex" alignItems="center" gap={8}>
    <TickIcon color="var(--gray-500)" />
    <Text fontWeight={300} fontSize={14} lineHeight="20px" color="var(--gray-600)" fontFamily="'Merriweather Sans', sans-serif">
      {text}
    </Text>
  </Pane>
);

export default SubscribeModal;
